export const AggregatorAbi = [
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint8",
						"name": "itemOne",
						"type": "uint8"
					},
					{
						"internalType": "uint8",
						"name": "itemTwo",
						"type": "uint8"
					},
					{
						"internalType": "enum IAggregator.DataSourse",
						"name": "sourseOne",
						"type": "uint8"
					},
					{
						"internalType": "enum IAggregator.DataSourse",
						"name": "sourseTwo",
						"type": "uint8"
					},
					{
						"internalType": "enum IAggregator.Operation",
						"name": "operation",
						"type": "uint8"
					}
				],
				"internalType": "struct IAggregator.OrderStep[]",
				"name": "order",
				"type": "tuple[]"
			},
			{
				"internalType": "bytes[]",
				"name": "results",
				"type": "bytes[]"
			}
		],
		"name": "executeCalculations",
		"outputs": [
			{
				"internalType": "bytes[]",
				"name": "",
				"type": "bytes[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes",
				"name": "requestData",
				"type": "bytes"
			}
		],
		"name": "executeContractCalls",
		"outputs": [
			{
				"internalType": "bytes[]",
				"name": "",
				"type": "bytes[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes",
				"name": "requestData",
				"type": "bytes"
			},
			{
				"internalType": "bytes",
				"name": "orderData",
				"type": "bytes"
			}
		],
		"name": "multicall",
		"outputs": [
			{
				"internalType": "int256",
				"name": "result",
				"type": "int256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes",
				"name": "",
				"type": "bytes"
			}
		],
		"name": "Output",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bytes[]",
				"name": "output",
				"type": "bytes[]"
			}
		],
		"name": "Output",
		"type": "event"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "address",
						"name": "contr",
						"type": "address"
					},
					{
						"internalType": "bytes4",
						"name": "func",
						"type": "bytes4"
					},
					{
						"internalType": "bytes",
						"name": "params",
						"type": "bytes"
					},
					{
						"internalType": "uint8",
						"name": "extractItem",
						"type": "uint8"
					},
					{
						"internalType": "bool",
						"name": "isResultTuple",
						"type": "bool"
					},
					{
						"internalType": "bool",
						"name": "isParam",
						"type": "bool"
					},
					{
						"internalType": "int256",
						"name": "value",
						"type": "int256"
					}
				],
				"internalType": "struct IAggregator.RequestItem[]",
				"name": "requests",
				"type": "tuple[]"
			}
		],
		"name": "encodeCalls",
		"outputs": [
			{
				"internalType": "bytes",
				"name": "",
				"type": "bytes"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"components": [
					{
						"internalType": "uint8",
						"name": "itemOne",
						"type": "uint8"
					},
					{
						"internalType": "uint8",
						"name": "itemTwo",
						"type": "uint8"
					},
					{
						"internalType": "enum IAggregator.DataSourse",
						"name": "sourseOne",
						"type": "uint8"
					},
					{
						"internalType": "enum IAggregator.DataSourse",
						"name": "sourseTwo",
						"type": "uint8"
					},
					{
						"internalType": "enum IAggregator.Operation",
						"name": "operation",
						"type": "uint8"
					}
				],
				"internalType": "struct IAggregator.OrderStep[]",
				"name": "orders",
				"type": "tuple[]"
			}
		],
		"name": "encodeOptions",
		"outputs": [
			{
				"internalType": "bytes",
				"name": "",
				"type": "bytes"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	}
] as const;